import { stepMedicalExpensesExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['prescriptionMedicinesNotInjury',
    'prescriptionMedicinesForInjury',
    'selectedClaimFor',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `medicalExpensesExpense.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpense(data);

  return [...medicalExpenses];
}

function mapToMedicalExpense(data) {
  const selectedClaimForArray = data.selectedClaimFor ? (!Array.isArray(data.selectedClaimFor)) ? data.selectedClaimFor.toJS() : data.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!data.expensesClaimed) {
    return [];
  }

  const claimCode = lookupClaimCode(data);
  return [{
    shortDescription: data.nameOfPhysicianFacilityFirstContacted,
    dateOfExpense: data.accidentFirstTreatment,
    clientCost: data.expensesClaimed,
    currency: data.currencyForProvide,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  }];
}

function lookupClaimCode(data) {
  const defaultClaimCode = expenseLookup.areYouClaimingForHospitalAndMedicalExpenses.claimCode;
  if (data.changeTo !== 'true') {
    return defaultClaimCode;
  }
  return !!expenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode ? expenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode : defaultClaimCode;
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList || [];
  const hasMedicalCode = (benefit) => {
    if (!benefit || claimCodeList.length === 0) {
      return false;
    }
    if (benefit.claimCode && claimCodeList.includes(benefit.claimCode)) {
      return true;
    }
    if (Array.isArray(benefit.codeList) && benefit.codeList.some((code) => claimCodeList.includes(code))) {
      return true;
    }
    return false;
  };

  if (selected.length > 0 && claimCodeList.length > 0 && !selected.some((sel) => hasMedicalCode(sel))
  ) {
    return list;
  }
  if (claimTypes !== undefined) {
    const medicalExpenses = mapToMedicalExpense(data);
    let selectedClaimCode = null;

    // Prefer claim code coming from selected benefits when available.
    if (claimCodeList.length > 0) {
      const selectedMedicalBenefit = selected.find((sel) => hasMedicalCode(sel));
      if (selectedMedicalBenefit) {
        if (selectedMedicalBenefit.claimCode && claimCodeList.includes(selectedMedicalBenefit.claimCode)) {
          selectedClaimCode = selectedMedicalBenefit.claimCode;
        } else if (Array.isArray(selectedMedicalBenefit.codeList)) {
          selectedClaimCode = selectedMedicalBenefit.codeList.find((code) => claimCodeList.includes(code)) || null;
        }
      }
    }

    // Fallback to lookup-based code to support flows where selected benefits omit medical rows.
    if (!selectedClaimCode) {
      selectedClaimCode = lookupClaimCode(data);
    }

    // Final fallback to first mapped medical claim type code.
    if (!selectedClaimCode && claimCodeList.length > 0) {
      const matchedClaimType = claimTypes.find((item) => claimCodeList.includes(item.claimCode));
      selectedClaimCode = matchedClaimType ? matchedClaimType.claimCode : null;
    }

    let matchedClaimType = null;
    if (selectedClaimCode) {
      matchedClaimType = claimTypes.find((item) => item.claimCode === selectedClaimCode);
    }
    if (!matchedClaimType && claimCodeList.length > 0) {
      matchedClaimType = claimTypes.find((item) => claimCodeList.includes(item.claimCode));
    }

    if (matchedClaimType) {
      const benefit = {
        claimCode: matchedClaimType.claimCode,
        description: 'Medical Expenses',
        claimTypeId: matchedClaimType.claimTypeId,
        requiredDocuments: matchedClaimType.requiredDocuments,
        order: null,
        expenses: medicalExpenses || [],
      };
      list.push(benefit);
    }
  }

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpensesDataMapper.js